<template>
  <el-dialog
          title="大OEM代理信息"
          :visible.sync="dialogVisible"
          customClass="customWidth"
          @opened="dialogOpen"
  >
    <el-form
            ref="form"
            :model="form"
            label-width="100px"
            size="mini"
    >
      <el-row>
        <el-col :span="8">
          <el-form-item
                  prop="legal"
                  label="姓名"
          >
            <el-input v-model="form.legal"   :disabled="true"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
                  prop="userName"
                  label="公司/个人"
          >
            <el-input v-model="form.userName"   :disabled="true"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
                  prop="mobileNo"
                  label="手机"
          >
            <el-input v-model="form.mobileNo"  :disabled="true"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item
                  prop="prov_cd"
                  label="省"
          >
            <el-select
                    class="filter-item"
                    v-model="form.prov_cd"
                    placeholder="请选择省"
                    :disabled="true"
                    @change="currentSel(form.prov_cd)"
            >
              <el-option
                      v-for="item in typeOptions"
                      :key="item.areaid"
                      :label="item.areaname"
                      :value="item.areaid"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
                  prop="city"
                  label="市"
          >
            <el-select
                    class="filter-item"
                    v-model="form.city"
                    placeholder="请选择市"
                    :disabled="true"
                    @change="currentSel2(form.city)"
            >
              <el-option
                      v-for="item in typeOptions2"
                      :key="item.areaid"
                      :label="item.areaname"
                      :value="item.areaid"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
                  prop="areaid"
                  label="区"
          >
            <el-select
                    class="filter-item"
                    v-model="form.areaid"
                    :disabled="true"
                    placeholder="请选择区"
            >
              <el-option
                      v-for="item in typeOptions3"
                      :key="item.areaid"
                      :label="item.areaname"
                      :value="item.areaid"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item
                  prop="compaddress"
                  label="地址"
          >
            <el-input v-model="form.compaddress"  :disabled="true"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
                  prop="contractstdate"
                  label="合同开始日期"
          >

            <el-date-picker
                    v-model="form.contractstdate"
                    type="date"
                    :picker-options="pickerOptions" value-format="yyyy-MM-dd"  :disabled="true">
            </el-date-picker>

          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
                  prop="contractendate"
                  label="合同结束日期"
          >
            <el-date-picker
                    v-model="form.contractendate"
                    type="date"
                    :picker-options="pickerOptions" value-format="yyyy-MM-dd"  :disabled="true">
            </el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>

    </el-form>

    <el-tabs v-model="activeName" @tab-click="handleClick" >
      <el-tab-pane label="一级代理" name="first">
        <child1  v-if="isChildUpdate1" :agentid_f="agentid_f" :xt_id_f="xt_id_f" :dl_type_f="dl_type_f"></child1>

      </el-tab-pane>
      <el-tab-pane label="二级代理" name="second">
        <child2 v-if="isChildUpdate2"  :agentid_f2="agentid_f2" :xt_id_f2="xt_id_f2" :dl_type_f2="dl_type_f2"></child2>

      </el-tab-pane>
      <el-tab-pane label="三级代理" name="third">
        <child3 v-if="isChildUpdate3"  :agentid_f3="agentid_f3" :xt_id_f3="xt_id_f3" :dl_type_f3="dl_type_f3"></child3>
      </el-tab-pane>
      <el-tab-pane label="商户列表" name="fourth">
        <child4 v-if="isChildUpdate4"  :agentid_f4="agentid_f4" :xt_id_f4="xt_id_f4" :dl_type_f4="dl_type_f4"></child4>
      </el-tab-pane>
    </el-tabs>

  </el-dialog>

</template>
<style>
  .customWidth{
    width:80%;
  }
</style>
<script>
    import * as agentService from "@/api/sys/agent";
    import * as userService from "@/api/sys/user";
    import util from '@/libs/util.js'
    import tabZujianChild1 from '@/pages/sys/oneagent/tabZujianChild1'
    import tabZujianChild2 from '@/pages/sys/oneagent/tabZujianChild2'
    import tabZujianChild3 from '@/pages/sys/oneagent/tabZujianChild3'
    import tabZujianChild4 from '@/pages/sys/oneagent/tabZujianChild4'
    export default {
        name: "agentViewForm",
        components:{
            child1:tabZujianChild1,
            child2:tabZujianChild2,
            child3:tabZujianChild3,
            child4:tabZujianChild4
        },
        props: {
            agent: Object,
            value: Boolean
        },
        data() {
            return {
                loading: false,
                dialogVisible: false,
                activeName:'first',
                pickerOptions: {}, // 日期设置对象
                isChildUpdate1:true,
                isChildUpdate2:false,
                isChildUpdate3:false,
                isChildUpdate4:false,
                xt_id_f:"",
                agentid_f:"",
                dl_type_f:"",

                xt_id_f2:"",
                agentid_f2:"",
                dl_type_f2:"",

                xt_id_f3:"",
                agentid_f3:"",
                dl_type_f3:"",

                xt_id_f4:"",
                agentid_f4:"",
                dl_type_f4:"",
                form: {
                    legal: "",
                    userName: "",
                    mobileNo: "",
                    compaddress: "",
                    contractstdate: "",
                    contractendate: ""
                },
                typeOptions: [],
                typeOptions2: [],
                typeOptions3: []
            };
        },
        watch: {
            value(val) {
                this.dialogVisible = val;
            },
            dialogVisible(val) {
                this.$emit("input", val);
                console.log("===this.agent.xt_id====="+this.agent.xt_id);
                this.xt_id_f=this.agent.xt_id;
                this.agentid_f=this.agent.agentid;
                this.dl_type_f=this.agent.dl_type;

                this.xt_id_f2=this.agent.xt_id;
                this.agentid_f2=this.agent.agentid;
                this.dl_type_f2=this.agent.dl_type;

                this.xt_id_f3=this.agent.xt_id;
                this.agentid_f3=this.agent.agentid;
                this.dl_type_f3=this.agent.dl_type;


                this.xt_id_f4=this.agent.xt_id;
                this.agentid_f4=this.agent.agentid;
                this.dl_type_f4=this.agent.dl_type;
            }
        },
        methods: {
            dialogOpen() {
                this.$refs.form.resetFields();
                var formData2 = new FormData() // 声明一个FormData对象
                agentService.getProvcd(formData2).then(data => {
                    this.typeOptions=data;
                });
                if(this.agent.city){
                    this.currentSel(this.agent.prov_cd);
                }
                if(this.agent.areaid){
                    this.currentSel2(this.agent.city);
                }
                if (this.agent.userId) {
                    // userService.getUser(this.user.id).then(data => {
                    let form = {};
                    form.legal = this.agent.legal;
                    form.userName = this.agent.userName;
                    form.mobileNo = this.agent.mobileNo;
                    form.prov_cd = this.agent.prov_cd;
                    form.city = this.agent.city;
                    form.areaid = this.agent.areaid;
                    form.compaddress = this.agent.compaddress;
                    form.contractstdate = this.agent.contractstdate;
                    form.contractendate = this.agent.contractendate;

                    this.form = form;
                    // });
                } else {
                    this.form = {};
                }
            },
            handleClick(tab, event) {
                console.log(tab, event);
                if(tab.name == 'first'){
                    // 触发‘配置管理’事件
                    this.isChildUpdate1 = true;
                    this.isChildUpdate2 = false;
                    this.isChildUpdate3 = false;
                    this.isChildUpdate4 = false;
                }else if(tab.name == 'second'){
                    // 触发‘用户管理’事件
                    this.isChildUpdate1 = false;
                    this.isChildUpdate2 = true;
                    this.isChildUpdate3 = false;
                    this.isChildUpdate4 = false;
                }else if(tab.name == 'third'){
                    // 触发‘用户管理’事件
                    this.isChildUpdate1 = false;
                    this.isChildUpdate2 = false;
                    this.isChildUpdate3 = true;
                    this.isChildUpdate4 = false;
                }else if(tab.name == 'fourth'){
                    // 触发‘用户管理’事件
                    this.isChildUpdate1 = false;
                    this.isChildUpdate2 = false;
                    this.isChildUpdate3 = false;
                    this.isChildUpdate4 = true;
                }
            },
            currentSel(val) {
                if (this.agent.userId) {
                    this.form.city = "";
                    this.form.areaid = "";
                }
                this.typeOptions2=[];
                var formData2 = new FormData() // 声明一个FormData对象

                formData2.append('type','city')
                formData2.append('areaid',val)
                agentService.getProvcd(formData2).then(data => {
                    this.typeOptions2=data;
                });
            },
            currentSel2(val) {
                this.typeOptions3=[];
                var formData2 = new FormData() // 声明一个FormData对象
                formData2.append('type','area')
                formData2.append('areaid',val)
                agentService.getProvcd(formData2).then(data => {
                    this.typeOptions3=data;
                });
            },
            destroyed(){
                console.log("销")
            },
          close() {
                this.$refs["form"].resetFields();
                this.dialogVisible = false;
            }
        }
    };
</script>
